import { connect } from 'react-redux'

import { doDeleteReplyDraft, handleUpdateReplyDraftDelayed } from 'ducks/drafts'
import { selectIsFetchingCannedReplyForInsert } from 'selectors/app'
import { selectIsForwarding } from 'selectors/page'
import { selectAccountPrefersReplyOpen } from 'selectors/app/selectAccountPreferences'

import EmailComposer from './view'

const select = state => ({
  isInsertingCannedReply: selectIsFetchingCannedReplyForInsert(state),
  isForwarding: selectIsForwarding(state),
  prefersOpen: selectAccountPrefersReplyOpen(state),
})

const perform = dispatch => ({
  doDeleteReplyDraft: ticketId => dispatch(doDeleteReplyDraft(ticketId)),
  // bindActionCreators not playing well with our curried action creators
  updateDraftDelayed: (ticketId, prop, val, opts) =>
    handleUpdateReplyDraftDelayed(dispatch, ticketId, prop, val, opts),
})

export default connect(select, perform)(EmailComposer)
